import { createComponent } from "react-fela";
import resourceData from "~/data/resource-data.json";
import { textStyles } from "~/styleguide/typography";
import { useRef } from "react";

import get from "lodash.get";

import SummaryTextOnly from "~/components/resource/summary/text-only";

export default ({ resources, hasSidebar, type }) => {
    const ledeText = get(resourceData, "data.acf.sales_glossary_lede");
    const previousLetterRef = useRef(null);
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    // Create a set of glossary letters to determine which should have links
    const glossaryLettersSet = new Set();
    resources.forEach(resource => {
      const glossaryTerm = get(resource, "glossary-term");
      if (glossaryTerm) {
        glossaryLettersSet.add(glossaryTerm[0].toUpperCase());
      }
    });

    return (
        <ResourceListing hasSidebar={hasSidebar}>
            {/* Lede text - on Glossary only */}
            {type == "glossary" && ledeText && (
                <LedeText
                    dangerouslySetInnerHTML={{
                        __html: ledeText
                    }}
                />
            )}
            <GlossaryLinks>
            {alphabet.map(letter => (
              <span key={letter}>
                {glossaryLettersSet.has(letter) ? (
                  <a href={`#${letter}`}>{letter}</a>
                ) : (
                  <span>{letter}</span>
                )}
              </span>
            ))}
            </GlossaryLinks>

            {resources &&
                resources.length &&
                resources.map(resource => {
                  const glossaryTerm = get(resource, "glossary-term");
                  const glossaryLetter = glossaryTerm ? glossaryTerm[0].toUpperCase() : "";
                  const shouldRenderLetter = glossaryLetter !== previousLetterRef.current;
                  previousLetterRef.current = glossaryLetter;

                    return ([
                        <GlossaryHeader className={shouldRenderLetter} key={glossaryLetter}>
                        {shouldRenderLetter && <h2 id={glossaryLetter}>{glossaryLetter}</h2>}
                        </GlossaryHeader>,
                        <GlossaryWords key={resource.slug}>
                            <SummaryTextOnly
                                resource={resource}
                                type={type}
                            />
                        </GlossaryWords>
                    ]);
                })}

            </ResourceListing>
    );
};

const LedeText = createComponent(
    () => ({ ...textStyles.paragraphLarge }),
    "div",
    ["dangerouslySetInnerHTML"]
);

const ResourceListing = createComponent(({ hasSidebar }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  "> .true": {
      width: "100%"
  },
    extend: [
        {
            condition: hasSidebar,
            style: {
                flexBasis: "75%"
            }
        }
    ]
}));

const GlossaryLinks = createComponent(() => ({
    margin: "0 auto",
    padding: "12px 12px 8px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    "> span": {
        display: "inline-flex",
        fontSize: "14px",
        color: "#ccc",
        fontWeight: "700",
        padding: "6px",


    },
    "> span a": {
      padding: "6px",
      borderRadius: "6px",
      color: "#3b58f5",
    },
    "> span a:hover": {
        background: "#eee"
    }
}));

const GlossaryHeader = createComponent(() => ({
    "> h2": {
        fontSize: "36px",
        paddingTop: "100px"
    },
}));

const GlossaryWords = createComponent(() => ({
    display: "flex",
    width: "30%",
    marginRight: "3%"
}));
